import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import { AppLayout } from './components/layout/AppLayout';
import { Dashboard } from './pages/Dashboard';
import { LandRecordsList } from './pages/LandRecordsList';
import { LandRecordDetails } from './pages/LandRecordDetails';
import { LandRecordCreate } from './pages/LandRecordCreate';
import { Documents } from './pages/Documents';
import { Notifications } from './pages/Notifications';
import { Reports } from './pages/Reports';
import { MasterData } from './pages/MasterData';
import { UsersRoles } from './pages/UsersRoles';
import { Settings } from './pages/Settings';
function AppContent() {
  const {
    state
  } = useApp();
  const {
    currentView
  } = state;
  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'land-records':
        return <LandRecordsList data-id="element-1" />;
      case 'land-record-details':
        return <LandRecordDetails data-id="element-2" />;
      case 'create-record':
      case 'land-record-edit':
        return <LandRecordCreate data-id="element-3" />;
      case 'documents':
        return <Documents data-id="element-4" />;
      case 'notifications':
        return <Notifications data-id="element-5" />;
      case 'reports':
        return <Reports data-id="element-6" />;
      case 'master-data':
        return <MasterData data-id="element-7" />;
      case 'users-roles':
        return <UsersRoles data-id="element-8" />;
      case 'settings':
        return <Settings data-id="element-9" />;
      default:
        return <Dashboard data-id="element-10" />;
    }
  };
  return <AppLayout data-id="element-11">{renderView()}</AppLayout>;
}
export function App() {
  return <AppProvider data-id="element-12">
      <AppContent data-id="element-13" />
    </AppProvider>;
}